import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DatePicker, Input, Spin, Pagination } from 'antd';
import MoreMeeting from '../meeting/MoreMeeting';
import moment from 'moment';

export default ({ intl, dispatch, loading, roomReport }) => {
  const {
    startTime,
    endTime,
    meetingName,
    searchData,
    pageNo,
    pageSize,
    meetingSearchInfo,
    meetingTreeData
  } = roomReport;
  const {
    moreMeeting = [],
  } = meetingSearchInfo;
  const meetingTree = meetingTreeData || { child: [] };
  const tableList = (data = [], pageNo, startTime, endTime, dispatch) => {
    return data.map((item, index) => {
      let currentDate = new Date();
      return (
        <li key={index}>
          <div className="tip-case reportTable">
            <div className="meeting-index">{(pageNo - 1) * 10 + index + 1}</div>
            <div className="meeting-area">{item['zoneName']}</div>
            <div className="meeting-name">{intl.messages.locale === 'en_US'?item['roomNameEn']:item['roomName']}</div>
            <div className="meeting-num">{item['bookNum']}</div>
            <div className="sign-num">{item['signMeetingNum']}</div>
            <div className="sign-length">
              {Math.ceil((item['meetingLength'] / 60) * 100) / 100}
            </div>
            <div className="meeting-occupy">
              {Math.ceil(item['bookRate'] * 100) / 100}%
            </div>
            <div className="meeting-occupy">{item['expireRate']}%</div>
            <div
              className="meeting-detail"
              onClick={() => {
                dispatch({
                  type: 'roomAbnormallyDetails/clickToDetail',
                  roomSummary: item,
                  startTime: startTime
                    ? startTime.valueOf()
                    : currentDate.getTime(),
                  endTime: endTime ? endTime.valueOf() : currentDate.getTime()
                });
              }}
            >
              <FormattedMessage id="search_right_menu_details" />
            </div>
          </div>
        </li>
      );
    });
  };
  return (
    <div className="message-body report-room report-container">
      {/*<div className="messages-first">
        <div className="nav">
          <a>
            <FormattedMessage id="report_report" />/
            <FormattedMessage id="report_abnormal_meeting_statis" />
          </a>
        </div>
      </div>*/}
      <div className="room-report-container">
        <Spin spinning={loading} size="large">
          <div className="messages-list roomReport room-report-title">
            <div className="messages-title roomReport-head">
              <div className="report-div report-area">
                <label className="report-search-label">
                  <FormattedMessage id="report_area" />
                </label>
                <div className="search-input">
                <span className="menu-border">
                  <i className="iconfont icon-sousuo" />
                  <MoreMeeting
                    meetingTree={meetingTree}
                    intl={intl}
                    placeHolder={intl.formatMessage({
                      id: 'report_room_place_holder'
                    })}
                    selected={moreMeeting}
                    onMeetingChange={v => {
                      // dispatch({type: 'top/setMeetingSearchInfo', meetingSearchInfo: {...meetingSearchInfo, moreMeeting: v}})
                      dispatch({
                        type: 'roomAbnormallyReport/setState',
                        payload: {
                          meetingSearchInfo: {
                            ...meetingSearchInfo,
                            moreMeeting: v
                          }
                        }
                      });
                    }}
                  />
                </span>
                </div>
              </div>
              <div className="report-div report-meeting-name">
                <label className="report-search-label">
                  <FormattedMessage id="report_meeting_name" />
                </label>
                <Input
                  placeholder={intl.formatMessage({ id: 'report_pls_name_f' })}
                  value={meetingName}
                  onChange={e => {
                    dispatch({
                      type: 'roomAbnormallyReport/setState',
                      payload: { meetingName: e.target.value }
                    });
                  }}
                />
              </div>
              <div className="report-div report-date">
                <label className="report-search-label" >
                  <FormattedMessage id="report_date" />
                </label>
                <div>
                  <DatePicker
                    allowClear={false}
                    value={startTime}
                    disabledDate={current => {
                      return (
                        current &&
                        current.startOf('day').valueOf() >=
                        endTime.startOf('day').valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'roomAbnormallyReport/setState',
                        payload: { startTime: e }
                      });
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    value={endTime}
                    disabledDate={current => {
                      return (
                        startTime.valueOf() > current.valueOf() ||
                        current.startOf('day').valueOf() >=
                        moment()
                          .startOf('day')
                          .valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'roomAbnormallyReport/setState',
                        payload: { endTime: e }
                      });
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-btn-group">
                <button
                  className="button_primary"
                  onClick={() => {
                    dispatch({ type: 'roomAbnormallyReport/search' });
                  }}
                >
                  <FormattedMessage id="report_search" />
                </button>
                <button
                  onClick={() => {
                    dispatch({ type: 'roomAbnormallyReport/downloadRoom' });
                  }}
                >
                  <FormattedMessage id="report_download" />
                </button>
              </div>
            </div>
          </div>

          <div
            className="messages-list roomReport room-report-table"
            style={{ height: '620px' }}
          >
            <div className="tip-case reportTable">
              <div className="meeting-index">
                {intl.formatMessage({ id: 'report_no' })}
              </div>
              <div className="meeting-area">
                {intl.formatMessage({ id: 'report_area' })}
              </div>
            .
              <div className="meeting-name">
                {intl.formatMessage({ id: 'report_meeting_name' })}
              </div>
              <div className="meeting-num">
                {intl.formatMessage({ id: 'report_roomDetail_bookNum' })}
              </div>
              <div className="sign-num">
                {intl.formatMessage({ id: 'report_sign_num' })}
              </div>
              <div className="sign-length">
                {intl.formatMessage({ id: 'report_occupancy_time' })}
                (h)
              </div>
              <div className="meeting-occupy">
                {intl.formatMessage({ id: 'report_use_rate' })}
              </div>
              <div className="meeting-occupy">
                {intl.formatMessage({ id: 'report_disuse_rate' })}
              </div>
              <div className="meeting-detail">
                <FormattedMessage id="report_detail" />
              </div>
            </div>
            <ul
              className={
                searchData.list == undefined
                  ? ''
                  : searchData.list.length == 0
                  ? 'emptyData'
                  : 'messages'
              }
            >
              {searchData.list == undefined
                ? ''
                : searchData.list.length == 0
                  ? intl.formatMessage({ id: 'smart_device_drop_down_no_data' })
                  : ''}
              {searchData.list &&
              tableList(searchData.list, pageNo, startTime, endTime, dispatch)}
            </ul>
            <div className="page-cont">
              {searchData.total && searchData.total > 0 ? (
                <Pagination
                  total={searchData.total || 0}
                  showQuickJumper
                  showSizeChanger
                  pageSize={pageSize || 10}
                  current={pageNo || 1}
                  onShowSizeChange={(page, pageSize) => {
                    dispatch({
                      type: 'roomAbnormallyReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize}
                    });
                  }}
                  onChange={(page, pageSize) => {
                    dispatch({
                      type: 'roomAbnormallyReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize }
                    });
                  }}
                />
              ) : null}
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/RoomReportAbnormally.js